// extracted by mini-css-extract-plugin
export default {"Item":"lmnbh2Jg3h9zAD2JdmcR","ItemName":"F9OLtGsYOnEkCukBfAnG","ItemInfo":"xvwJM8BwsoKw5xR8Tobh","ItemPoints":"WBWvO8Ize6U334aVxFb2","ItemPrice":"DIqgRpImf00jOtGd5edx"};